import { useEffect, useRef } from 'react';
import { createRoot } from 'react-dom/client';
const $ = jQuery;

import './style.scss';
import Style from './Style';
import { drags } from './utils/functions';

// Image Compare
document.addEventListener('DOMContentLoaded', () => {
	const imgCompareEls = document.querySelectorAll('.wp-block-icb-image-compare');
	imgCompareEls.forEach(imgCompareEl => {
		const attributes = JSON.parse(imgCompareEl.dataset.attributes);

		createRoot(imgCompareEl).render(<>
			<Style attributes={attributes} clientId={attributes.cId} />

			<ImageCompare attributes={attributes} />
		</>);

		imgCompareEl?.removeAttribute('data-attributes');
	});
});

const ImageCompare = ({ attributes }) => {
	const { beforeImg, afterImg, isLabel, beforeLabel, afterLabel, isCap, cap } = attributes;

	const imgCompareRef = useRef(null);
	const dividerRef = useRef(null);
	const resizeRef = useRef(null);
	const beforeImgRef = useRef(null);

	const setImgWidth = width => {
		beforeImgRef.current.style.width = width;
		beforeImgRef.current.style.minWidth = width;
	}

	// Image Slider Scripts
	useEffect(() => {
		const compareEl = imgCompareRef.current

		const handleResize = () => {
			const imgCompareWidth = compareEl?.clientWidth;

			if (imgCompareWidth) {
				setImgWidth(`${imgCompareWidth}px`);
				drags($(dividerRef.current), $(resizeRef.current), $(compareEl));
			}
		};

		const observer = new ResizeObserver(handleResize);

		if (compareEl) {
			observer.observe(compareEl);
		}

		window.addEventListener('resize', handleResize);

		return () => {
			observer.disconnect();
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	return <div className='icbImageCompare' ref={imgCompareRef}>
		<div className='comparison-slider'>
			{isLabel && afterLabel && <div className='overlay afterLabel' dangerouslySetInnerHTML={{ __html: afterLabel }} />}
			<img className='afterImg' src={afterImg?.url} alt={afterImg?.alt} />

			<div className='resize' ref={resizeRef}>
				{isLabel && beforeLabel && <div className='overlay beforeLabel' dangerouslySetInnerHTML={{ __html: beforeLabel }} />}
				<img className='beforeImg' src={beforeImg?.url} alt={beforeImg?.alt} ref={beforeImgRef} />
			</div>

			<div className='divider' ref={dividerRef}></div>
		</div>

		{isCap && cap && <div className='caption' dangerouslySetInnerHTML={{ __html: cap }} />}
	</div>
}